import { motion } from "framer-motion";

const principles = [
  {
    title: "Focus isn't linear",
    description: <>You were doing something… then something else pulled you away. <span className="text-[#0CBCBF]">That's normal.</span></>
  },
  {
    title: "Losing your place happens",
    description: <>You switch tabs, check something, and it's gone. <span className="text-[#0CBCBF]">You're not broken.</span></>
  },
  {
    title: "Getting back matters",
    description: <>One tap, and you're back where you left off. No restart. <span className="text-[#0CBCBF]">Just continue.</span></>
  }
];

export const PhilosophySection = () => {
  return (
    <section 
      id="philosophy"
      data-testid="philosophy-section"
      className="py-20 md:py-28 px-6 md:px-12 relative overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-b from-white to-[#FDFBF7]" />
      
      <div className="max-w-4xl mx-auto relative">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <p className="text-sm font-medium uppercase tracking-widest text-[#0CBCBF] mb-4">
            Our philosophy
          </p>
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-[#27272A]">
            Emotion is infrastructure
          </h2>
        </motion.div>

        {/* Principles - horizontal on desktop - with depth */}
        <div className="grid md:grid-cols-3 gap-6">
          {principles.map((principle, index) => (
            <motion.div
              key={principle.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              data-testid={`philosophy-principle-${index}`}
              className="bg-white/90 backdrop-blur-sm p-6 rounded-2xl text-center relative overflow-hidden"
              style={{
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.04), 0 4px 12px rgba(0, 0, 0, 0.06), 0 12px 32px rgba(0, 0, 0, 0.05)'
              }}
            >
              {/* Card surface depth */}
              <div 
                className="absolute inset-0 pointer-events-none rounded-2xl"
                style={{ background: 'linear-gradient(180deg, rgba(255,255,255,0.8) 0%, transparent 40%)' }}
              />
              <div 
                className="absolute inset-0 pointer-events-none rounded-2xl"
                style={{ background: 'linear-gradient(0deg, rgba(0,0,0,0.02) 0%, transparent 30%)' }}
              />
              
              <div className="w-10 h-10 rounded-full bg-[#F58227]/10 flex items-center justify-center mb-4 mx-auto relative z-10">
                <span className="text-[#F58227] font-bold">{index + 1}</span>
              </div>
              <h3 className="text-lg font-semibold text-[#27272A] mb-2 relative z-10">
                {principle.title}
              </h3>
              <p className="text-sm text-[#52525B] relative z-10">
                {principle.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
